'use client';

import z from 'zod';
import { PortableText, PortableTextTypeComponent } from '@portabletext/react';
import {
  blockContent,
  mediaSection,
  columnInfoGroup,
  simpleDatalistSection
} from '@stereoagency/sanity-schema';
import LinkAnnotationComponent from './LinkAnnotationComponent.client';
import MediaSection from '@/components/sections/MediaSection.client';
import ColumnInfoGroup from '@/components/sections/ColumnInfoGroup.client';
import SimpleDatalistSection from '@/components/sections/SimpleDatalistSection.client';
import TextAlignmentAnnotationComponent from './TextAlignmentAnnotationComponent.client';
import { CallToActionsBlockComponent } from './CallToActionsBlockComponent';

interface Props {
  value: z.infer<typeof blockContent.validator>;
}

const MediaSectionPortableTextComponent: PortableTextTypeComponent<
  z.infer<typeof mediaSection.validator>
> = ({ value }) => (
  <div className="p">
    <MediaSection {...value} />
  </div>
);

const ColumnInfoGroupPortableTextComponent: PortableTextTypeComponent<
  z.infer<typeof columnInfoGroup.validator>
> = ({ value }) => (
  <div className="p">
    <ColumnInfoGroup {...value} />
  </div>
);

const SimpleDatalistSectionTextComponent: PortableTextTypeComponent<
  z.infer<typeof simpleDatalistSection.validator>
> = ({ value }) => (
  <div className="p">
    <SimpleDatalistSection {...value} />
  </div>
);

export default function BlockContent({ value }: Props) {
  return (
    <PortableText
      value={value}
      components={{
        types: {
          mediaSection: MediaSectionPortableTextComponent,
          columnInfoGroup: ColumnInfoGroupPortableTextComponent,
          simpleDatalistSection: SimpleDatalistSectionTextComponent,
          callToActionsBlock: CallToActionsBlockComponent
        },
        marks: {
          link: LinkAnnotationComponent,
          textAlignment: TextAlignmentAnnotationComponent
        }
      }}
    />
  );
}
